import React, { ReactNode } from 'react'

import { Button, ButtonProps } from '../../components/button/button.js'
import { Card } from '../../components/card/card.js'
import { GridColumn } from '../../components/grid/grid-column.js'
import { Grid } from '../../components/grid/grid.js'
import { Product, ProductProps } from '../../components/product/product.js'

export interface NotificationPageProps {
    title: string
    tag?: ReactNode
    children: ReactNode
    button?: ButtonProps
    additionalInfo?: ReactNode
    activeSubscriptions?: ProductProps[]
}

export const NotificationPage = (props: NotificationPageProps): JSX.Element => {
    return (
        <Grid>
            <GridColumn offset={['md-3']} width={['md-6', 'xs-10']} className="h-text-center">
                <h1>{props.title}</h1>
            </GridColumn>

            <GridColumn offset={['md-3']} width={['md-6', 'xs-10']} className="h-text-center">
                <div className="text">{props.children}</div>
            </GridColumn>

            {props.activeSubscriptions && props.activeSubscriptions.length > 0 && (
                <GridColumn offset={['lg-3']} width={['lg-6', 'xs-10']} className="notification__cards">
                    {props.activeSubscriptions.map((productProps, index) => (
                        <Card key={'card' + index} variant="ternary" padding="small" hasContent={true}>
                            <Product {...productProps} />
                        </Card>
                    ))}
                </GridColumn>
            )}

            {props.button && (
                <GridColumn offset={['md-3']} width={['md-6', 'xs-10']} className="h-text-center">
                    <Button {...props.button} />
                </GridColumn>
            )}

            {props.additionalInfo && (
                <GridColumn offset={['md-3']} width={['md-6', 'xs-10']} className="h-text-center">
                    {props.additionalInfo}
                </GridColumn>
            )}
        </Grid>
    )
}
